import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';

import Container from '../../containers/Container';
import Picto from '../../components/Picto';
import Grid from '../../components/Grid';
import Button from '../../components/Button';
import PdfLoader from '../../utils/PdfLoader';
import styles from './styles';

const LIST = ['foncier', 'matiere', 'energie', 'eau', 'chantier', 'menage', 'bio'];

class HomePanorma extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentItem: 'foncier' };
    this.onNext = this.onNext.bind(this);
  }

  onSelect(item) {
    this.setState({ currentItem: item });
  }

  onNext() {
    const { currentItem } = this.state;
    const idx = LIST.indexOf(currentItem);
    const newIdx = idx >= LIST.length - 1 ? 0 : idx + 1;
    const newItem = LIST[newIdx];
    this.setState({ currentItem: newItem });
  }

  renderPicto(item) {
    const { classes } = this.props;
    const { currentItem } = this.state;
    const disabled = currentItem !== item;
    return (
      <IconButton
        key={item}
        className={`${classes.pictoContainer} ${disabled ? classes.pictoDisabled : ''}`}
        disabled={!disabled}
        onClick={() => this.onSelect(item)}
      >
        <Picto name={item} disabled={disabled} width="100%" height="100%" />
      </IconButton>
    );
  }

  renderNextButton() {
    const { classes } = this.props;
    return (
      <IconButton className={classes.nextButton} color="inherit" size="medium" onClick={this.onNext}>
        <ArrowForwardIcon fontSize="large" />
      </IconButton>
    );
  }

  renderItem(item) {
    const { classes, data } = this.props;
    const { currentItem } = this.state;
    const block = data.home.panorama;
    const texts = block[item];
    const current = currentItem === item;
    return (
      <Slide key={item} direction="left" in={current}>
        <div className={`${classes.itemContainer} ${current ? '' : classes.itemDisabled}`}>
          <Grid xs={12} md={3} spacing={6} className={classes.itemGrid}>
            <div key="title">
              <Typography className={`${classes.titleContent} ${classes[`title_${item}`]}`} variant="h4">
                {parse(texts.title)}
              </Typography>
            </div>
            <div key="desc1" className={classes.desc}>
              <Typography variant="subtitle1" className={classes.subtitle}>
                {parse(block.subtitle1)}
              </Typography>
              <Typography>{parse(texts.desc1)}</Typography>
            </div>
            <div key="desc2" className={classes.desc}>
              <Typography variant="subtitle1" className={classes.subtitle}>
                {parse(block.subtitle2)}
              </Typography>
              <Typography>{parse(texts.desc2)}</Typography>
            </div>
            <div key="desc3" className={`${classes.desc} ${classes.desc3} ${classes[`desc3_${item}`]}`}>
              <Typography variant="subtitle1" className={classes.subtitle}>
                {parse(block.subtitle3)}
              </Typography>
              <Typography>{parse(texts.desc3)}</Typography>
            </div>
          </Grid>
        </div>
      </Slide>
    );
  }

  render() {
    const { classes, data } = this.props;
    const { panorama: block } = data.home;
    return (
      <Container className={classes.container} id="home-panorama">
        <Typography variant="h3" className={classes.title}>
          {parse(block.title)}
        </Typography>
        <Typography variant="subtitle1">{parse(block.desc)}</Typography>
        <div className={classes.titleSep}></div>
        <Button className={classes.buttonPdf} color="grey" onClick={PdfLoader(block.pdf)}>
          {parse(block.button)}
        </Button>
        <div className={classes.contentContainer}>
          <div className={classes.pictosContainer}>
            {LIST.map(item => this.renderPicto(item))}
            {this.renderNextButton()}
          </div>
          <div className={classes.itemsContainer}>{LIST.map(item => this.renderItem(item))}</div>
        </div>
      </Container>
    );
  }
}

HomePanorma.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomePanorma);
